import React, { useEffect, useState } from 'react'
import Table from 'components/Shared/Table'
import { fetchFerryServices, markFerryServiceAsDeleted } from 'services'
import { createColumns } from 'components/FerryServices/FerryServicesTable/columns'
import { useHistory } from 'react-router-dom'
import { useErrorHandling } from 'context/errorHandling'
import { Loader } from 'components/Shared/Loader'
import {
    FERRY_SERVICE_CREATE,
  FERRY_SERVICE_DELETE,
  FERRY_SERVICE_EDIT,
  useAuth
} from 'context/auth'

export function FerryServicesTable () {
  const history = useHistory()
  const [columns, setColumns] = useState()

  const { handleError } = useErrorHandling()
  const { hasAnyPrivileges } = useAuth()

  useEffect(() => {
      setColumns(createColumns(hasAnyPrivileges))
  }, [hasAnyPrivileges, handleError])

  const handleAddButtonClick = () => {
    history.push('/ferry-services/create')
  }

  const handleMenuEditClick = item => {
    history.push(`/ferry-services/edit/${item.id}`)
  }

  const handleRowClick = item => {
    history.push(`/ferry-services/details/${item.id}`)
  }

  const addButton = {
    label: 'ferryServices.table.addButton',
    onClick: handleAddButtonClick,
    isClickable: hasAnyPrivileges([FERRY_SERVICE_CREATE])
  }

  const menuOptions = {
    edit: {
      onClick: handleMenuEditClick,
      isEditable: () => hasAnyPrivileges([FERRY_SERVICE_EDIT])
    },
    delete: {
      onDelete: markFerryServiceAsDeleted,
      deleteDialog: {
        title: 'ferryServices.table.deleteDialog.title',
        content: 'ferryServices.table.deleteDialog.content'
      },
      isDeletable: () => hasAnyPrivileges([FERRY_SERVICE_DELETE])
    }
  }

  return columns
    ? (
      <Table title="ferryServices.table.title"
             tableKey="ferryServices"
             columns={columns}
             fetchData={fetchFerryServices}
             addButton={addButton}
             menu={menuOptions}
             onRowClick={handleRowClick}
             hiddenFilters={[{
               key: 'markedAsDeleted',
               value: false
             }]}
      />
    )
    : <Loader/>
}
